import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TmService {
  constructor() {}

  private getUserErrorCount = new BehaviorSubject<number>(0);
  private blockGetUserCalls = new BehaviorSubject<boolean>(false);

  setUserErrorCountValue(value: number) {
    this.getUserErrorCount.next(value);
  }

  getUserErrorCountValue() {
    return this.getUserErrorCount.asObservable();
  }

  setBlockGetUserCallsValue(value: boolean) {
    this.blockGetUserCalls.next(value);
  }

  getBlockGetUserCallsValue() {
    return this.blockGetUserCalls.asObservable();
  }
  //  getUserErrorCount: number = new BehaviorSubject<number>(0);
}
